import { useContext, useEffect } from "react";
import { LoaderDisbatch } from "../../contexts/loader";
import { useParams } from "react-router-dom";

const url =
  "http://localhost:5001/deft-cef16/us-central1/deployment/preview/ryleys-app/hYStixHGDGDzPAXNUGsPqQGY";

export default function Preview() {
  const setLoader = useContext(LoaderDisbatch);
  const { appId, pageId } = useParams();

  function onLoadEnd(e) {
    setLoader(false);
  }

  useEffect(() => {
    setLoader(true);
  }, []);
  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <iframe
        style={{ width: "100vw", height: "100vh" }}
        frameborder="0"
        border="0"
        cellspacing="0"
        width={"100vw"}
        onLoad={onLoadEnd}
        height={"100vh"}
        src={`http://localhost:5001/deft-cef16/us-central1/deployment/preview/${appId}/${pageId}`}
      />
    </div>
  );
}
